var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInclusionbelonging(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39999 11C11.6091 11 13.4 9.20914 13.4 7C13.4 4.79086 11.6091 3 9.39999 3C7.19085 3 5.39999 4.79086 5.39999 7C5.39999 9.20914 7.19085 11 9.39999 11Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39999 21V19C3.39999 17.9391 3.82142 16.9217 4.57157 16.1716C5.32171 15.4214 6.33913 15 7.39999 15H11.4C12.4609 15 13.4783 15.4214 14.2284 16.1716C14.9786 16.9217 15.4 17.9391 15.4 19V21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 3.12988C17.2604 3.35018 18.023 3.85058 18.5676 4.55219C19.1122 5.2538 19.4078 6.11671 19.4078 7.00488C19.4078 7.89305 19.1122 8.75596 18.5676 9.45757C18.023 10.1592 17.2604 10.6596 16.4 10.8799",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 20.9999V18.9999C21.3949 18.1171 21.0979 17.2607 20.5553 16.5643C20.0126 15.8679 19.2548 15.3706 18.4 15.1499",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInclusionbelonging);
export default __webpack_public_path__ + "static/media/inclusion.belonging.4f1aed5b5e655542af363e6659a4c465.svg";
export { ForwardRef as ReactComponent };